import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_INCIDENTS,
  CREATE_INCIDENT,
  GET_INCIDENT_BY_ID,
  UPDATE_INCIDENT,
  CREATE_COMPONENT_SERVICE,
  GET_COMPONENT_SERVICES,
  GET_STATUS_PAGE_PUBLIC,
  GET_TIMESTAMP_DATA,
  GET_UPTIME_DETAILS,
  DELETE_COMPONENT_SERVICE,
  DELETE_INCIDENT,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE,
  GET_INCIDENTS_PUBLIC_PAGE,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY,
  VERIFY_RECAPTCHA,
  SUBSCRIBE_TO_STATUS_PAGE,
  STATUS_PAGE_EMAIL_CONFIRMATION,
  GET_EXTERNAL_COMPONENT_SERVICES,
  GET_AWS_HEALTH_EVENTS,
  MAP_ALERTS_TO_COMPONENT_SERVICE,
  GET_MAPPED_ALERTS,
  GET_ALL_RESOURCES,
  GET_RESOURCES_COUNT,
  DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE
} from './actionTypes';

import {
  createIncidentSuccess,
  createIncidentFail,
  getIncidentsSuccess,
  getIncidentsFail,
  getIncidentByIdSuccess,
  getIncidentByIdFail,
  updateIncidentSuccess,
  updateIncidentFail,
  createComponentServiceSuccess,
  createComponentServiceFail,
  getComponentsSuccess,
  getComponentsFail,
  getStatusPageStateSuccess,
  getStatusPageStateFail,
  getTimeStampDataSuccess,
  getTimeStampDataFail,
  getUptimeDetailsSuccess,
  getUptimeDetailsFail,
  deleteComponentServiceSuccess,
  deleteComponentServiceFail,
  deleteIncidentSuccess,
  deleteIncidentFail,
  getTimeStampDataForOneDaySuccess,
  getTimeStampDataForOneDayFail,
  getComponentsPublicPageSuccess,
  getComponentsPublicPageFail,
  getIncidentsPublicPageSuccess,
  getIncidentsPublicPageFail,
  getTimeStampDataForOneDayPublicPage,
  getTimeStampDataPublicPageFail,
  getTimeStampDataPublicPageSuccess,
  getTimeStampDataForOneDayPublicPageSuccess,
  getTimeStampDataForOneDayPublicPageFail,
  verifyRecaptchaFail,
  verifyRecaptchaSuccess,
  subscribeToStatusPageSuccess,
  subscribeToStatusPageFail,
  statusPageEmailConfirmationSuccess,
  statusPageEmailConfirmationFail,
  getExternalComponentsSuccess,
  getExternalComponentsFail,
  getAWsHealthEventsSuccess,
  getAWsHealthEventsFail,
  mapAlertsToComponentsFail,
  getMappedAlertsSuccess,
  getMappedAlertsFail, mapAlertsToComponentServiceSuccess,
  getAllResourcesSuccess,
  getAllResourcesFail,
  getResourcesCountSuccess,
  getResourcesCountFail,
  disassociateAlertToComponentServiceSuccess,
  disassociateAlertToComponentsFail
} from './actions';

import {
  getIncidentsUrl,
  postCreateIncident,
  getIncidentByIdUrl,
  updateIncidentUrl,
  createComponentService,
  getComponentService,
  getStatusPageState,
  getTimestampData,
  getUptimeCheckDetailsURL,
  deleteComponentServiceUrl,
  deleteIncidentUrl,
  getTimeStampDataForOneDay,
  getComponentServicePublicPageUrl,
  getIncidentsPublicPageUrl,
  getTimestampDataPublicPage,
  getTimeStampDataForOneDayPublicPageUrl,
  verifyRecaptchaToken,
  subscribeToStatusPage,
  statuspageEmailConfirmation,
  getExternalComponents,
  getAWSHealthEvents,
  mapAlertsToComponentServiceUrl,
  getMappedAlertsUrl,getAllResourcesUrl, getResourcesCountUrl,
  disassociateAlertToComponentService
} from "../../helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";
import { func } from 'prop-types';

function* onGetIncidents() {
    try {
        const response = yield call(getIncidentsUrl);
        yield put(getIncidentsSuccess(response));
    } catch (error) {
        yield put(getIncidentsFail(error));
    }
}
function* onGetIncidentsPublicPage() {
  try {
    const response = yield call(getIncidentsPublicPageUrl);
    yield put(getIncidentsPublicPageSuccess(response));
  } catch (error) {
    yield put(getIncidentsPublicPageFail(error));
  }
}
function* onCreateIncident({ payload }) {
  try {
    const response = yield call(postCreateIncident, payload);
    if (response){
      showNotification("success", "Incident created successfully");
      yield put({type: GET_INCIDENTS});
    }
  } catch (error) {
    yield put(createIncidentFail(error.response?.data?.message || "Failed to create incident"));
  }
}
function* onGetComponentServices() {
    try {
      const response = yield call(getComponentService);
      yield put(getComponentsSuccess(response));
    } catch (error) {
      yield put(getComponentsFail(error));
    }
  }

function* onGetComponentServicesPublicPage() {
  try {
    const response = yield call(getComponentServicePublicPageUrl);
    yield put(getComponentsPublicPageSuccess(response));
  } catch (error) {
    yield put(getComponentsPublicPageFail(error));
  }
}

function*  onCreateComponentService({ payload }) {
    try {
      const response = yield call(createComponentService, payload);
      if (response){
        showNotification("success", "Component Service created successfully");
        yield put({type: GET_INCIDENTS});
        yield put ({type: GET_COMPONENT_SERVICES});
      }
    } catch (error) {
      yield put(createComponentServiceFail(error.response?.data?.message || "Failed to create component service"));
    }
  }

  function* onGetIncidentById({ payload: { incident_id } }) {
    try {
      const response = yield call(getIncidentByIdUrl, incident_id);
      yield put(getIncidentByIdSuccess(response));
    } catch (error) {
      yield put(getIncidentByIdFail(error.response?.data?.message));
    }
  }

  function* onUpdateIncident({ payload: { incident } }) {
    try {
      const response = yield call(updateIncidentUrl, {
        incident_id: incident.id,
        name: incident.name,
        status: incident.status,
        severity: incident.severity,
        message: incident.message,
        description: incident.description,
        affected_service_details: incident.affected_service_details
      });
      
      if (response) {
        showNotification("success", "Updated Incident");
        yield put({type: GET_INCIDENTS});
      }
    } catch (error) {
      yield put(updateIncidentFail(error.response?.data?.message));
    }
  }

function* onGetStatusPageState() {
  try {
    const response = yield call(getStatusPageState);
    yield put(getStatusPageStateSuccess(response));
  } catch (error) {
    yield put(getStatusPageStateFail(error));
  }
}

function* onGetTimestampData({payload: data}) {
  try {
    const response = yield call(getTimestampData, data);
    yield put(getTimeStampDataSuccess(response));
  } catch (error) {
    yield put(getTimeStampDataFail(error));
  }
}

function* onGetTimestampDataForOneDay({payload: data}) {
  try {
    const response = yield call(getTimeStampDataForOneDay, data);
    yield put(getTimeStampDataForOneDaySuccess(response));
  }
  catch (error) {
    yield put(getTimeStampDataForOneDayFail(error));
  }
}

function* onGetTimestampDataPublicPage({payload: data}) {
  try {
    const response = yield call(getTimestampDataPublicPage, data);
    yield put(getTimeStampDataPublicPageSuccess(response));
  } catch (error) {
    yield put(getTimeStampDataPublicPageFail(error));
  }
}

function* onGetTimestampDataForOneDayPublicPage({payload: data}) {
  try {
    const response = yield call(getTimeStampDataForOneDayPublicPageUrl, data);
    yield put(getTimeStampDataForOneDayPublicPageSuccess(response));
  }
  catch (error) {
    yield put(getTimeStampDataForOneDayPublicPageFail(error));
  }
}


function* onGetUptimeCheckDetails(){
  try {
    const response = yield call(getUptimeCheckDetailsURL);
    yield put(getUptimeDetailsSuccess(response));
  } catch (error) {
    yield put(getUptimeDetailsFail(error));
  }
}

function* deleteComponentService({payload:data}) {
  try {
    const response = yield call(deleteComponentServiceUrl, data);
    yield put(deleteComponentServiceSuccess(response));
  } catch (error) {
    yield put(deleteComponentServiceFail(error));
  }
}

function* deleteIncident({payload:data}) {
  try {
    const response = yield call(deleteIncidentUrl, data);
    yield put(deleteIncidentSuccess(response));
    yield put({type: GET_INCIDENTS});
  } catch (error) {
    yield put(deleteIncidentFail(error));
  }
}

function* onVerifyRecaptcha(action) {
  try {
    const { token } = action.payload;
    const response = yield call(verifyRecaptchaToken, token);
    if (response.success && response.score >= 0.5) {
      yield put(verifyRecaptchaSuccess(response.success));
    } else {
      const errorMessage = response.error || 'Verification failed';
      yield put(verifyRecaptchaFail(errorMessage));
    }
  } catch (error) {
    yield put(verifyRecaptchaFail('Verification failed. Please try again.'));
  }
}

function* onSubscribeToStatusPage({payload:data}) {
  try {
    const response = yield call(subscribeToStatusPage, data );
    if (response) {
      showNotification("success", "Verification email has been sent, Please Verify");
      yield put(subscribeToStatusPageSuccess(response));
    }
  } catch (error) {
    yield put(subscribeToStatusPageFail(error));
  }
}

function* onStatusPageEmailConfirmation({payload: {token}}) {
  try {
    const response = yield call(statuspageEmailConfirmation, token);
    yield put(statusPageEmailConfirmationSuccess(response.message))
  } catch (error) {
    yield put(statusPageEmailConfirmationFail(error.response.data.message));
  }
}

function* onGetExternalComponentServices() {
  try {
    const response = yield call(getExternalComponents);
    yield put(getExternalComponentsSuccess(response));
  } catch (error) {
    yield put(getExternalComponentsFail(error));
  }
}

function* onGetAWSHealthEvents(){
  try{
    const response = yield call(getAWSHealthEvents);
    yield put(getAWsHealthEventsSuccess(response));
  }
  catch (error) {
    yield put(getAWsHealthEventsFail(error));
  }
}

function* onMapAlertsToComponentService(data) {
  try{
    const response = yield call(mapAlertsToComponentServiceUrl, data.payload)
    yield put(mapAlertsToComponentServiceSuccess(response))
    yield put({type: GET_MAPPED_ALERTS});
  } catch(error) {
    yield put(mapAlertsToComponentsFail(error))
  }
}

function* onDisassociateAlertToComponentService(data){
  try{
    const response = yield call(disassociateAlertToComponentService, data.payload)
    yield put(disassociateAlertToComponentServiceSuccess(response))
    yield put({type: GET_MAPPED_ALERTS});
  } catch(error) {
    yield put(disassociateAlertToComponentsFail(error));
  }
}

function* onGetMappedAlerts(){
  try {
    const response = yield call(getMappedAlertsUrl);
    yield put(getMappedAlertsSuccess(response));
  }
  catch (error) {
    yield put(getMappedAlertsFail(error));
  }
}

function* onGetAllResources({payload: {page_filters}}){
  try {
    const response = yield call(getAllResourcesUrl, page_filters);
    yield put(getAllResourcesSuccess(response));
  }
  catch (error) {
    yield put(getAllResourcesFail(error));
  }
}

function* onGetResourcesCount({payload: {page_filters}}){
  try {
    const response = yield call(getResourcesCountUrl, page_filters);
    yield put(getResourcesCountSuccess(response));
  }
  catch (error) {
    yield put(getResourcesCountFail(error));
  }
}

function* incidentsSaga() {
    yield takeEvery(GET_INCIDENTS, onGetIncidents);
    yield takeEvery(CREATE_INCIDENT, onCreateIncident);
    yield takeEvery(GET_INCIDENT_BY_ID, onGetIncidentById);
    yield takeEvery(UPDATE_INCIDENT, onUpdateIncident);
    yield takeEvery(CREATE_COMPONENT_SERVICE, onCreateComponentService);
    yield takeEvery(GET_COMPONENT_SERVICES, onGetComponentServices);
    yield takeEvery(GET_STATUS_PAGE_PUBLIC, onGetStatusPageState);
    yield takeEvery(GET_TIMESTAMP_DATA, onGetTimestampData);
    yield takeEvery(GET_TIMESTAMP_DATA_FOR_ONE_DAY, onGetTimestampDataForOneDay);
    yield takeEvery(GET_UPTIME_DETAILS, onGetUptimeCheckDetails);
    yield takeEvery(DELETE_COMPONENT_SERVICE, deleteComponentService);
    yield takeEvery(DELETE_INCIDENT, deleteIncident);
    yield takeEvery(GET_COMPONENT_SERVICES_PUBLIC_PAGE, onGetComponentServicesPublicPage);
    yield takeEvery(GET_INCIDENTS_PUBLIC_PAGE, onGetIncidentsPublicPage);
    yield takeEvery(GET_TIMESTAMP_DATA_PUBLIC_PAGE, onGetTimestampDataPublicPage);
    yield takeEvery(GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY, onGetTimestampDataForOneDayPublicPage);
    yield takeEvery(VERIFY_RECAPTCHA, onVerifyRecaptcha);
    yield takeEvery(SUBSCRIBE_TO_STATUS_PAGE, onSubscribeToStatusPage);
    yield takeEvery(STATUS_PAGE_EMAIL_CONFIRMATION, onStatusPageEmailConfirmation);
    yield takeEvery(GET_EXTERNAL_COMPONENT_SERVICES, onGetExternalComponentServices);
    yield takeEvery(GET_AWS_HEALTH_EVENTS, onGetAWSHealthEvents);
    yield takeEvery(MAP_ALERTS_TO_COMPONENT_SERVICE, onMapAlertsToComponentService);
    yield takeEvery(GET_MAPPED_ALERTS, onGetMappedAlerts);
    yield takeEvery(GET_ALL_RESOURCES, onGetAllResources);
    yield takeEvery(GET_RESOURCES_COUNT, onGetResourcesCount);
    yield takeEvery(DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE, onDisassociateAlertToComponentService);
}

export default incidentsSaga;
